import { render } from "./InstantQuote.vue?vue&type=template&id=454529a8&scoped=true"
import script from "./InstantQuote.vue?vue&type=script&lang=js"
export * from "./InstantQuote.vue?vue&type=script&lang=js"

import "./InstantQuote.vue?vue&type=style&index=0&id=454529a8&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-454529a8"]])

export default __exports__